import duoHeader from './layout/duo-header';
import duoStepper from './layout/duo-stepper';
import duoFooter from './layout/duo-footer';

export default {
    'duo-header': duoHeader,
    'duo-stepper': duoStepper,
    'duo-footer': duoFooter
}
